<app-header></app-header>
<app-leftsidebar></app-leftsidebar>

<main class="lp">
  <!-- ============================ HERO ============================ -->
  <section class="lp-hero">
    <img class="lp-hero-map" [src]="activeWorld.image" [alt]="'The shared world of ' + activeWorld.name" />
    <div class="lp-hero-scrim"></div>

    <div class="lp-pins">
      <div
        class="lp-pin-spot"
        *ngFor="let pin of activeWorld.pins"
        [ngClass]="pinSpotClass(pin)"
        [class.is-open]="pin.id === selectedPinId"
        [style.top]="pin.top"
        [style.left]="pin.left"
      >
        <button
          type="button"
          class="lp-pin"
          [attr.aria-expanded]="pin.id === selectedPinId"
          (click)="selectPin(pin, $event)"
          (mouseenter)="selectPin(pin)"
        >{{ pin.name }}</button>
        <ng-container *ngIf="pin.id === selectedPinId" [ngTemplateOutlet]="advCard" [ngTemplateOutletContext]="{ pin: pin, docked: false }"></ng-container>
      </div>
    </div>

    <div class="lp-hero-inner">
      <span class="lp-eyebrow">Shared world · {{ activeWorld.name }}</span>
      <h1 class="lp-title">Your worlds,<br /><span class="gold">shared.</span></h1>
      <p class="lp-lede">
        One atlas, every table. An inn, a temple, a dungeon becomes a pin every
        other Game Master can find, run and rate, the same night you publish it.
      </p>
      <div class="lp-cta">
        @if (userdata) {
          <a class="btn btn-theme" routerLink="/maplist">Open maps</a>
          <a class="btn btn-outline" routerLink="/char-portfolio">My characters</a>
        } @else {
          <button type="button" class="btn btn-theme" (click)="signUp()">Sign up</button>
          <button type="button" class="btn btn-outline" (click)="logIn()">Log in</button>
        }
        <a class="lp-cta-link" routerLink="/learn-more/false">See how it works</a>
      </div>
      @if (!userdata) {
        <p class="lp-note">
          The pins on the map are a public sample — a free account opens the whole atlas.
        </p>
      }

      <dl class="lp-stats">
        <div><dd>{{ activeWorld.pinsPlaced | number }}</dd><dt>Pins placed</dt></div>
        <div><dd>{{ activeWorld.contributors | number }}</dd><dt>Contributors</dt></div>
        <div><dd>{{ activeWorld.gamesRunning | number }}</dd><dt>Games running</dt></div>
      </dl>
      <p class="lp-hint">Tap a pin to open its card</p>

      <div class="lp-adv-dock">
        <ng-container *ngIf="selectedPin" [ngTemplateOutlet]="advCard" [ngTemplateOutletContext]="{ pin: selectedPin, docked: true }"></ng-container>
      </div>
    </div>
  </section>

  <ng-template #advCard let-pin="pin">
    <article
      class="content-tile flip-card lp-adv"
      [class.is-flipped]="isFlipped('pin-' + pin.id)"
      tabindex="0"
      role="link"
      [attr.aria-label]="pin.adventure.name"
      (click)="onHeroTileActivate(pin, $event)"
      (keydown)="onHeroTileKey(pin, $event)"
    >
      <span class="flip-inner">
        <span class="flip-face flip-front">
          <span class="content-tile-img" [style.background-image]="'url(' + pinImage(pin) + ')'"></span>
          <span class="content-tile-name">{{ pin.adventure.name }}</span>
        </span>
        <span class="flip-face flip-back">
          <span class="tile-back-tags">
            <span class="chip chip-type">{{ pin.adventure.type }}</span>
            <span class="chip chip-neutral">{{ pin.adventure.price }}</span>
          </span>
          <span class="tile-back-title">{{ pin.adventure.name }}</span>
          <span class="tile-back-desc">{{ pin.adventure.desc }}</span>
          <span class="tile-back-foot">
            <span class="tile-back-by">{{ pin.adventure.author }} · {{ activeWorld.name }}</span>
            <span class="tile-back-rating">{{ pin.adventure.rating }} ★ · {{ pin.adventure.reviews }}</span>
            <span class="tile-back-meta">{{ pin.adventure.playtime }} · {{ pin.adventure.party }}</span>
          </span>
          <span class="tile-back-cta">View in store</span>
        </span>
      </span>
    </article>
  </ng-template>

  <!-- Shared Worlds / Maps: hero picker — not a store rail -->
  <section class="lp-worlds">
    <div class="lp-worlds-head">
      <span class="lp-eyebrow">Shared worlds</span>
      <p>Pick one to preview it on the map above. Your own worlds live in Maps, signed in.</p>
    </div>

    <div class="lp-worlds-rail">
      <button
        type="button"
        class="world-card"
        *ngFor="let world of visibleWorlds"
        [class.is-active]="world.key === activeWorldKey"
        [class.is-flipped]="isFlipped('world-' + world.key)"
        [attr.aria-pressed]="world.key === activeWorldKey"
        [attr.aria-label]="'Preview ' + world.name"
        (click)="onWorldCardClick(world, $event)"
      >
        <span class="world-card-copy">
          <span class="world-card-name">{{ world.name }}</span>
          <span class="world-card-meta">{{ world.gamesystem }}</span>
        </span>
        <span class="flip-inner">
          <span class="flip-face flip-front">
            <span class="world-card-img" [style.background-image]="'url(' + world.image + ')'"></span>
          </span>
          <span class="flip-face flip-back">
            <span class="world-back-pitch">{{ world.pitch }}</span>
            <dl class="world-back-stats">
              <div class="world-back-stat">
                <dd>{{ world.pinsPlaced | number }}</dd>
                <dt>Pins</dt>
              </div>
              <div class="world-back-stat">
                <dd>{{ world.contributors | number }}</dd>
                <dt>Contributors</dt>
              </div>
              <div class="world-back-stat">
                <dd>{{ world.gamesRunning | number }}</dd>
                <dt>Games</dt>
              </div>
            </dl>
            <span class="world-back-cta">Preview this world</span>
          </span>
        </span>
      </button>
    </div>
  </section>

  <ng-container *ngFor="let block of pageBlocks; let last = last; trackBy: trackRail">
    <section class="lp-section" *ngIf="block.kind === 'featured-map'" [class.lp-section--last]="last">
      <a class="featured-map" (click)="handleNavigationToMap()">
        <h2 class="lp-h2 featured-map-title">The world of <span class="gold">Ashmorrow</span></h2>
        <img class="featured-map-img" src="assets/images/Ashmorrow.jpeg" alt="The world map of Ashmorrow" />
      </a>
    </section>

    <ng-container *ngIf="block.kind === 'rail'">
      <app-store-rail [rail]="block.rail" [last]="last" [signedIn]="!!userdata?.id"></app-store-rail>
    </ng-container>
  </ng-container>
</main>

<app-footer></app-footer>
